module.exports = __webpack_public_path__ + "c5800016fb584c9b107e3570b5d91583.png";